<template>
  <ol class="steps">
    <li
      :to="{ name: step.routeName }"
      class="step"
      v-for="(step) in steps"
      :key="step.route"
      :aria-current="isCurrent(step)"
      :class="{ 'is-done': isDone(step),
                'is-active': isCurrent(step) }"
    >{{stepDetail(step)}}</li>
  </ol>
</template>

<script>
import { find, startsWith, isUndefined } from 'lodash';

const name = 'step-tracker';

export default {
    name,
    componentName: name,

    props: {
        steps: { type: Array, default: [] },
        currentStep: { type: Number, default: 1 },
    },

    data() {
        return {
            langRoot: 'stepTrackerPasswordRecover',
        };
    },

    created() {
        this.steps = [
            {
                index: 1,
                name: this.$t(`${this.langRoot}.step.username`),
                routeName: 'passwordreset.username',
            },
            {
                index: 2,
                name: this.$t(`${this.langRoot}.step.questions`),
                routeName: 'passwordreset.security',
            },
            {
                index: 3,
                name: this.$t(`${this.langRoot}.step.reset`),
                routeName: 'passwordreset.new',
            },
            {
                index: 4,
                name: this.$t(`${this.langRoot}.step.complete`),
                routeName: 'passwordreset.complete',
            },
        ];
    },

    computed: {
        currentStep() {
            let step = find(this.steps, (step) => {
                return startsWith(this.$route.name, step.routeName);
            });
            return step;
        },
        stepLabel() {},
    },

    methods: {
        isDone(step) {
            if (isUndefined(step) || isUndefined(this.currentStep)) {
                return;
            }

            return parseInt(this.currentStep.index, 10) > parseInt(step.index, 10);
        },
        isCurrent(step) {
            return startsWith(this.$route.name, step.routeName);
        },
        setStep(step) {
            this.currentStep = step;
        },
        stepDetail(step) {
            let number = step.index;
            let label = step.name;
            return `${number}. ${label}`;
        },
    },
};
</script>



// WEBPACK FOOTER //
// login/Components/PasswordStepTracker.vue